import React from 'react';
import {GridColDef, GridRenderEditCellParams, useGridApiContext} from '@mui/x-data-grid-pro';
import {Stack} from '@mui/material';

import {ColumnProps} from '@utils/table/columnTypes.table';
import {Array} from '@utils/extensions/array.extension';

import {SelectItem} from '@components/inputs/select/Select.component';
import AsyncSelectWithSearchComponent from '@components/inputs/asyncSelect/AsyncSelectWithSearch.component';
import {Observable} from 'rxjs';

interface AsyncSelectColumnComponentProps extends GridRenderEditCellParams {
  getOptions: (search?: string) => Observable<SelectItem[]>;
}

const AsyncSelectColumnComponent = (props: AsyncSelectColumnComponentProps) => {
  const {id, field, getOptions, value} = props;

  const apiRef = useGridApiContext();

  return (
    <Stack flex={1}>
      <AsyncSelectWithSearchComponent
        getOptions={getOptions}
        handleChange={(newValue) => apiRef.current.setEditCellValue({id, field, value: newValue})}
        value={value ?? ''}
      />
    </Stack>
  );
};

interface SelectColumnProps extends ColumnProps {
  disabled?: (row: any) => boolean;
  hideInput?: (row: any) => boolean;
  getOptions: (search?: string) => Observable<SelectItem[]>;
}

export const COLUMN_TYPE_ASYNC_SELECT = (props: SelectColumnProps): GridColDef => ({
  cellClassName: (params) => Array.mapNotNull([props.cellClassName?.(params)])?.join(' ') ?? '',
  field: props.field ?? '',
  headerName: props.label,
  flex: props.fullWidth ? 1 : undefined,
  minWidth: props.minWidth ?? 50,
  sortable: props.sortable ?? false,
  editable: !props.disabled,
  // renderCell: (params) => {
  //   return (
  //     <Stack flex={1}>
  //       <AsyncSelectWithSearchComponent readOnly getOptions={props.getOptions ?? []} value={params.value ?? ''}/>
  //     </Stack>
  //   );
  // },
  renderEditCell: (params) => {
    if (props.hideInput?.(params.row)) {
      return params.value;
    }
    return <AsyncSelectColumnComponent {...params} getOptions={props.getOptions ?? []}/>;
  },
  valueGetter: props.valueGetter,
  valueFormatter: props.valueFormatter,
  width: props.width ?? 150,
});
